import PropTypes from "prop-types";
import React, { Suspense, lazy } from "react";
import ScrollToTop from "./helpers/scroll-top";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ToastProvider } from "react-toast-notifications";
import { connect } from "react-redux";
import { BreadcrumbsProvider } from "react-breadcrumbs-dynamic";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";

// home pages
const HomeFashion = lazy(() => import("./pages/home/HomeFashion"));
const TheClubInfo = lazy(() => import("./pages/other/TheClubInfo"));
const PropuseInfo = lazy(() => import("./pages/other/PropuseInfo"));
const About = lazy(() => import("./pages/other/About"));
// shop pages

const ShopGridFullWidth = lazy(() => import("./pages/shop/ShopGridFullWidth"));

// product pages
const Product = lazy(() => import("./pages/shop-product/Product"));

// blog pages
const BlogStandard = lazy(() => import("./pages/blog/BlogStandard"));
const BlogDetailsStandard = lazy(() =>
  import("./pages/blog/BlogDetailsStandard")
);
// other pages
const Contact = lazy(() => import("./pages/other/Contact"));
const MyAccount = lazy(() => import("./pages/other/MyAccount"));
const LoginRegister = lazy(() => import("./pages/other/LoginRegister"));

const Cart = lazy(() => import("./pages/other/Cart"));
const Checkout = lazy(() => import("./pages/other/Checkout"));

const NotFound = lazy(() => import("./pages/other/NotFound"));
const Faq = lazy(() => import("./pages/other/Faq"));
const ShopFree  = lazy(() => import("./pages/shop/ShopFree"));
const OrderHandler = lazy(() => import("./pages/OrderComponent/OrderHandler"));
const initialOptions = {
  "client-id": process.env.REACT_APP_PAYPAL_ID,
  currency: "USD",
};
const App = () => {
  return (
    <ToastProvider placement="bottom-left">
      <BreadcrumbsProvider>
        <PayPalScriptProvider options={initialOptions}>
          <Router>
            <ScrollToTop>
              <Suspense
                fallback={
                  <div className="flone-preloader-wrapper">
                    <div className="flone-preloader">
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                }
              >
                <Switch>
                  <Route
                    exact
                    path={process.env.PUBLIC_URL + "/"}
                    component={HomeFashion}
                  />

                  {/* Homepages */}
                  <Route
                    path={process.env.PUBLIC_URL + "/home-fashion"}
                    component={HomeFashion}
                  />

                  {/* Shop pages */}
                  <Route exact path="/faq" component={Faq} />
                  <Route exact path="/about" component={About} />
                                    <Route exact path="/success" component={OrderHandler} />
                  <Route exact path="/pending" component={OrderHandler} />
                  <Route exact path="/failure" component={OrderHandler} />
                  <Route exact path="/the-club-info" component={TheClubInfo} />
                  <Route exact path="/propuse-info" component={PropuseInfo} />
                  <Route
                    path={process.env.PUBLIC_URL + "/shop"}
                    component={ShopGridFullWidth}
                  />
 <Route
                    path={process.env.PUBLIC_URL + "/shop-free"}
                    component={ShopFree}
                  />
                  {/* Shop product pages */}
                  <Route
                    path={process.env.PUBLIC_URL + "/product/:id"}
                    render={(routeProps) => (
                      <Product
                        {...routeProps}
                        key={routeProps.match.params.id}
                      />
                    )}
                  />

                  <Route
                    path={process.env.PUBLIC_URL + "/blog-post/:id"}
                    component={BlogDetailsStandard}
                  />

                  {/* Blog pages */}
                  <Route
                    path={process.env.PUBLIC_URL + "/blog"}
                    component={BlogStandard}
                  />

                  {/* Other pages */}

                  <Route
                    path={process.env.PUBLIC_URL + "/contact"}
                    component={Contact}
                  />
                  <Route
                    path={process.env.PUBLIC_URL + "/my-account"}
                    component={MyAccount}
                  />
                  <Route
                    path={process.env.PUBLIC_URL + "/login-register"}
                    component={LoginRegister}
                  />

                  <Route
                    path={process.env.PUBLIC_URL + "/cart"}
                    component={Cart}
                  />

                  <Route
                    path={process.env.PUBLIC_URL + "/checkout"}
                    component={Checkout}
                  />

                  <Route
                    path={process.env.PUBLIC_URL + "/not-found"}
                    component={NotFound}
                  />

                  <Route exact component={NotFound} />
                </Switch>
              </Suspense>
            </ScrollToTop>
          </Router>
        </PayPalScriptProvider>
      </BreadcrumbsProvider>
    </ToastProvider>
  );
};

App.propTypes = {
  dispatch: PropTypes.func,
};

export default connect()(App);
